import { resources } from "@constants/hardcoded-strings";
import { MESSAGE_TEMPLATE_TYPE_OPTIONS } from "@constants/message-template-constants";
import { ContentPageBody } from "@containers/common/content-page-body/content-page-body";
import { ContentPageHeader } from "@containers/common/content-page-header/content-page-header";
import { InputFormGroup } from "@containers/common/input-form-group/input-form-group";
import { SelectFormGroup } from "@containers/common/select-form-group/select-form-group";
import { ToggleFormGroup } from "@containers/common/toggle-form-group/toggle-form-group";
import { TemplateAvailabilityLevelSection } from "@containers/modals/add-message-template-modal/template-availability-level-section/template-availability-level-section";
import { EntityStatusTypes } from "@enums/entity-status-types";
import { LabelWidthTypes } from "@enums/label-width-types";
import { SelectOption } from "@idw-types/common";
import { MessageTemplateGeneralInfoValidationErrors } from "@idw-types/common/validation/message-template/message-template-validation-errors";
import { IDWSession } from "@idw-types/data/idw-session";
import { FormattedMessageTemplate, SelfServiceVerificationWhitelabeledEmails } from "@idw-types/data/message-template";
import { AxnCompany } from "@idw-types/data/reference-data/axn";
import { isNullOrUndefined } from "@utils/object-util";
import { useState } from "react";

type MessageTemplateGeneralInfoTabProps = {
    session: IDWSession;
    state: FormattedMessageTemplate;
    axnCompanies: Array<AxnCompany>;
    selfServiceVerificationWhiteLabeledEmails: Array<SelfServiceVerificationWhitelabeledEmails>;
    isDisabled: boolean;
    labelWidth: LabelWidthTypes;
    validationErrors: MessageTemplateGeneralInfoValidationErrors;
    setMessageTemplateState: (state: FormattedMessageTemplate) => void;
};

export const MessageTemplateGeneralInfoTab = (props: MessageTemplateGeneralInfoTabProps) => {
    const {
        state,
        session,
        axnCompanies,
        selfServiceVerificationWhiteLabeledEmails,
        labelWidth,
        isDisabled,
        validationErrors,
        setMessageTemplateState
    } = props;

    type AddMessageTemplateState = {
        selectedDeliveryMethodOption: SelectOption;
    };
    const [newState, setNewState] = useState<AddMessageTemplateState>({
        selectedDeliveryMethodOption: isNullOrUndefined(state.type) ? null : { value: state.type, label: state.type },
    });

    const handleUpdateDeliveryMethod = (newValue: SelectOption) => {
        if (newValue) {
            setNewState(newState => ({
                ...newState,
                selectedDeliveryMethodOption: newValue
            }))
            setMessageTemplateState({
                ...state,
                type: newValue.value,
                sender: resources.pages.messageTemplateDetails.tabs.variables.defaultEmailSender.title

            })
        }
    }

    const handleMessageTemplateNameChange = (event: React.ChangeEvent<HTMLInputElement>) => {
        setMessageTemplateState({
            ...state,
            name: event.target.value
        });
    }

    const handleMessageTemplateStatus = (value: any) => {
        setMessageTemplateState({
            ...state,
            status: value ? EntityStatusTypes.ACTIVE : EntityStatusTypes.INACTIVE
        });
    }


    const resource = resources.pages.messageTemplateDetails.tabs.generalInfo;

    return (
        <div>
            <ContentPageHeader title={resource.title} />
            <ContentPageBody isMaxWidth={true}>
                <SelectFormGroup
                    controlId="delivery-method-input"
                    label={resources.modals.verificationLinkProvider.inputs.deliveryMethod.label}
                    ariaLabel={resources.modals.verificationLinkProvider.inputs.deliveryMethod.label}
                    automationId="delivery-method-input"
                    selectedOption={newState.selectedDeliveryMethodOption}
                    onChange={handleUpdateDeliveryMethod}
                    disabled={true}
                    isRequired={true}
                    options={MESSAGE_TEMPLATE_TYPE_OPTIONS}
                    isSearchable={true}
                    isClearable={false}
                    labelWidth={labelWidth}
                />
                <TemplateAvailabilityLevelSection
                    isDisabled={isDisabled}
                    session={session}
                    labelWidth={labelWidth}
                    axnCompanies={axnCompanies}
                    selfServiceVerificationWhiteLabeledEmails={selfServiceVerificationWhiteLabeledEmails}
                    state={state}
                    serviceOrganizationId={state.company?.id || null}
                    setState={setMessageTemplateState}
                    validationErrors={validationErrors}
                    newTemplate={false}
                />
                <InputFormGroup
                    controlId="message-template-name-input"
                    automationId="message-template-name-input"
                    label={resource.inputs.name.label}
                    ariaLabel={resource.inputs.name.label}
                    placeholder={resource.inputs.name.placeholder}
                    value={state.name}
                    onChange={handleMessageTemplateNameChange}
                    disabled={isDisabled}
                    isRequired={true}
                    labelWidth={labelWidth}
                />
                {validationErrors.nameError}

                <ToggleFormGroup
                    controlId={`message-template-status-radio-input`}
                    automationId={`message-template-status-radio-input`}
                    label={resource.inputs.status.label}
                    labelWidth={labelWidth}
                    onChange={handleMessageTemplateStatus}
                    checkedIcon={false}
                    uncheckedIcon={false}
                    checked={state.status === EntityStatusTypes.ACTIVE}
                    value={state.status}
                    isRequired={true}
                    disabled={isDisabled}
                />
            </ContentPageBody>
        </div>
    );
};